import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class BuildingStateService {

  private selectedBuildingSource = new BehaviorSubject<any>(null);
  selectedBuilding$ = this.selectedBuildingSource.asObservable();

  private popupPositionSource = new BehaviorSubject<{ x: number; y: number }>({ x: 0, y: 0 });
  popupPosition$ = this.popupPositionSource.asObservable();

  setSelectedBuilding(building: any): void {
    this.selectedBuildingSource.next(building);
  }

  setPopupPosition(position: { x: number; y: number }): void {
    this.popupPositionSource.next(position);
  }

  clearBuildingState(): void {
    this.selectedBuildingSource.next(null);
    this.popupPositionSource.next({ x: 0, y: 0 });
  }
}